import { render, staticRenderFns } from "./RoadBikeInsuranceCover.vue?vue&type=template&id=95410ada&scoped=true"
import script from "./RoadBikeInsuranceCover.vue?vue&type=script&lang=js"
export * from "./RoadBikeInsuranceCover.vue?vue&type=script&lang=js"
import style0 from "./RoadBikeInsuranceCover.vue?vue&type=style&index=0&id=95410ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95410ada",
  null
  
)

export default component.exports